// extracted by mini-css-extract-plugin
export default {"breadcrumb-container":"breadcrumb_breadcrumb-container__-HBkh"};